var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTongue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qs-popover-tongue",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 8",
    style: {
      enableBackground: "new 0 0 25 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0c-2.87,0-5.6,1.28-7.44,3.51l-2.84,3.43c-1.16,1.41-3.3,1.41-4.46,0L7.44,3.51C5.6,1.28,2.87,0,0,0H25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongue);
export default __webpack_public_path__ + "static/media/tongue.4d5160aa.svg";
export { ForwardRef as ReactComponent };